import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * Client-side redirect that preserves both the query string and the hash.
 * `to` is the destination pathname; params in it are literal (no :param
 * substitution beyond what the caller passes in). Use `RedirectWithParam`
 * when the path needs a route param appended.
 */
export function RedirectPreserving({ to }: { to: string }) {
  const loc = useLocation();
  return <Navigate to={{ pathname: to, search: loc.search, hash: loc.hash }} replace />;
}

/**
 * Preserves a single named route param, appending it to `basePath`.
 * Example: <RedirectWithParam basePath="/support/library" param="slug" />
 * redirects /manual/foo to /support/library/foo (with query + hash intact).
 */
export function RedirectWithParam({
  basePath,
  param,
}: {
  basePath: string;
  param: string;
}) {
  const params = useParams();
  const loc = useLocation();
  const seg = params[param] || "";
  return (
    <Navigate
      to={{ pathname: `${basePath}/${seg}`, search: loc.search, hash: loc.hash }}
      replace
    />
  );
}
